import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';
import { userActionTypes } from './util';

const actions = createActions({
  USER: {
    UPDATE_EMAIL: (newEmail) => ({ newEmail }),
    API: {
      UPDATE_EMAIL: userActionTypes()
    }
  }
})

export const apiAction = (authToken, newEmail) => commonApiActions.authenticated.post(`${API_ENDPOINT}/update-email`, authToken, newEmail, actions.user.api.updateEmail)

export function* updateUserEmail(action) {
  const authToken = yield select(authTokenSelector);

  yield put(apiAction(authToken, action.payload.newEmail));
}

const configuration = {
  name: 'updateEmail',
  action: actions,
  sagas: updateUserEmail,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true,
      isUpdating: true
    }),
    success: (state, action) => ({
      ...state,
      currentUser: {
        roleAssignments: state.currentUser.roleAssignments,
        teamMemberRoles: state.currentUser.teamMemberRoles,
        ...action.payload.user
      },
      isFetching: false,
      isUpdating: false,
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isUpdating: false,
      isFetching: false
    }),
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/updateEmail.js